import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'core-loader-button',
  templateUrl: './loader-button.component.html',
  styleUrls: ['./loader-button.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class LoaderButtonComponent {
  @Input()
  public readonly class: string;

  @Input()
  public readonly text: string;

  @Input()
  public readonly type = 'button';

  @Input()
  public readonly disabled = false;

  @Input()
  public readonly loading = false;
}
